import { useEffect, useState } from "react"
import { BasicPage } from "../../theme/Component/BasicPage"
import { _DocumentFactory, _single, _UBLInvoice } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { Modal } from "../../theme/Component/Modal"
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable"
import { AccountEditor } from "../../editor/AccountEditor"
import usePaginator from "../../theme/Component/usePaginator"
import { YearSelector } from "../../../core/shared/inputs/YearSelector"
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor"
import { SelectUBLDocumentTypeConstants } from "./Selectores/SelectUBLDocumentTypeConstants"
import { SelectDocumentStateConstants } from "./Selectores/SelectDocumentStateConstants"
import { ListMenu } from "../../theme/Component/ListMenu"
import { FireElectronicDocument } from "../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/FireElectronicDocument"
import { CreateUBLInvoiceItems } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoiveItem"
import { AccountantDocumentList } from "../../contract/etapa-contrato/contrac/ublinvoice/AccountantDocumentList/AccountantDocumentList"
import { HistoryUBLInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/HistoryUBLInvoice"
import { FileService } from "../../../core/services/FileService"
import { MakeUBLInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice"
import { BasicButton } from "../../theme/Component/BasicButton"
import useModal, { MODAL_XL } from "../../theme/Component/hooks/useModal"

interface Form {
    IDAccountSupplier: number | null;
    IDAccountCustomer: number | null;
    UblDocumentType: number | null;
    Year: number | null;
    Month: number | null;
    State: number | null;
}

interface PropEditor {
    label?: string;
    renderValue?: string;
    onChange?: any;
    typeUBL?:number;
}
export const UBLDocumentCatalogEditor = ({ label, renderValue,typeUBL, onChange }: PropEditor) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_UBLInvoice);
    const fileService = new FileService();
    const [registers, setRegisters] = useState<number>(15);
    const [response, setResponse] = useState<Form>({
        IDAccountCustomer: null,
        IDAccountSupplier: null,
        Month: null,
        State: null,
        UblDocumentType: typeUBL ?? null,
        Year: _single.getCurrenYear(),
    });
    const paginador = usePaginator();
    const [editor, setEditor] = useState<any>({
        Name: renderValue ?? ''
    });

    const [fileType, setFileType] = useState<string>(null);
    const [donwloadURL, setDonwloadURL] = useState<string>(null);
    const [urlFile, setUrlFile] = useState<string | null>(null);

    const modalEditor = useModal("Factura",MODAL_XL);


    useEffect(() => {
        if (onChange) {
            onChange(bean);
            setEditor({ ...editor, "Name": (bean.IDUBLInvoice ?? '') +" / "+ (bean.IssueDate ?? '')  });
        }
    }, [bean])

    useEffect(() => {
        if (donwloadURL) {
            const fetchPdf = async () => {
                try {
                    const data = await fileService.getPdfAsBase642(donwloadURL);
                    setUrlFile(data);
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };

            fetchPdf();
        }
    }, [donwloadURL]);

    useEffect(() => {
        setFileType(bean.MediaContext?.type || bean.Media?.split('.').pop())
        setDonwloadURL(fileService.getUrlFile(bean.MediaContext, bean.Media))
    }, [bean])

    const [modalB, setModalB] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalFire, setModalFire] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalSeeDoc, setModalSeeDoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalUBL, setModalUBL] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    useEffect(() => {
        setLista([])
        if (response.Year && response.UblDocumentType !== null && response.UblDocumentType !== undefined && !isNaN(response.UblDocumentType)) {
            getLista()
        }
    }, [paginador.page])

    const getLista = () => {
        instance.getUblDocumentInvoiceCatalog(response.IDAccountSupplier, response.IDAccountCustomer, response.UblDocumentType, response.Year, response.Month, response.State, paginador.page, registers).then(
            (resp) => {
                console.log(resp)
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountCustomerNit ?? "") + "-" + (user.DataBeanProperties.AccountCustomerName ?? "");
                        user.DataBeanProperties.Doc = (user.DataBeanProperties.FCMnemonic ?? "") + "-" + (user.DataBeanProperties.FCConsecutive ?? "") + "-" + (user.DataBeanProperties.FCDate ?? "");
                        user.DataBeanProperties.Remision = (user.DataBeanProperties.EAFMnemonic ?? "") + "-" + (user.DataBeanProperties.EAFConsecutive ?? "") + "-" + (user.DataBeanProperties.EAFDate ?? "")
                    });
                    setLista(x)
                }
            }
        ).catch(err => { console.log(err) })
    }


    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Nit-Cliente', property: 'Client', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
        { title: 'Entrada de Almacén/Remisión', property: 'Remision', visible: true },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Abrir Factura', icono: 'ri-file-list-line', visible: true, evento: () => { setModal({ ...modal, "name": "Abrir archivo", "view": true, "format": `${fileType !== "pdf" && "jpg" && "png" ? "modal-sm" : "modal-xl"}` }) } },
            { titulo: 'Ver eventos en la Factura', icono: 'ri-history-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true, "name": "Ver eventos en la Factura" }) } },
            { titulo: 'ver Items de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Factura` }) } },
            { titulo: 'Transmitir/Descargar Documento Electrónico', icono: 'ri-list-ordered', visible: true, evento: () => { setModalFire({ ...modalFire, "view": true, "name": `Transmitir/Descargar Documento` }) } },
            { titulo: 'Ver Documentos Contables', icono: 'ri-list-ordered', visible: true, evento: () => { setModalSeeDoc({ ...modalSeeDoc, "view": true, "name": `Ver Documentos Contables` }) } },
        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (_single.canCreate() && (response.Year && response.UblDocumentType !== null && response.UblDocumentType !== undefined && !isNaN(response.UblDocumentType))), icono: 'ri-file-add-line', evento: () => { setModalUBL({ ...modalUBL, "view": true, "name": "Agregar Factura Electronica" }) } }
    ]

    const update = () => {
        setModalUBL({ ...modalUBL, "view": false });
        getLista();
    }

    return (
        <>
            <label>{label ?? ''}</label>
            <input type="text" name="com" className="form-control" placeholder="clic para seleccionar" readOnly value={editor.Name} onClick={() => { modalEditor.open() }} />
           <Modal modal={modalEditor.modal} updateModal={modalEditor.setModal}>
            <>
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccountSupplier} label="Proveedor" onChange={(e) => { setResponse({ ...response, "IDAccountSupplier": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccountCustomer} label="Cliente" onChange={(e) => { setResponse({ ...response, "IDAccountCustomer": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <SelectUBLDocumentTypeConstants disable={typeUBL>=0} idSelect={response.UblDocumentType} onChange={(e) => { setResponse({ ...response, "UblDocumentType": e }) }} label="Tipo de Documento" />
                </div>
                <div className="col-md-6">
                    <YearSelector value={response.Year} onChange={(e) => { setResponse({ ...response, "Year": e }) }} tittle="Vigencia" />
                </div>
                <div className="col-md-6">
                    <MonthConstantsEditor idSelect={response.Month} onChange={(e) => { setResponse({ ...response, "Month": e }) }} label="Mes" name="Month" />
                </div>
                <div className="col-md-6">
                    <SelectDocumentStateConstants idSelect={response.State} onChange={(e) => { setResponse({ ...response, "State": e }) }} label="Estado" />
                </div>

            </div>
            <div className="row mt-4">
                <div className="col-md-4">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} />
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <BasicTable
                        iconButtons={iconButtonsItem}
                        // listButtons={listaBotones()}
                        head={head}
                        body={lista}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>
            </div>
            </>
           </Modal>

            <Modal modal={modalB} updateModal={setModalB} >
                <CreateUBLInvoiceItems idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} _onChange={() => { getLista(); }} />
            </Modal>

            <Modal modal={modal} updateModal={setModal} eventModal={() => { }} >
                <div className="row">
                    <div className="col-md-12">
                        <div className="iframe-container">

                            {fileType ?
                                <>
                                    {fileType === 'pdf' && (
                                        urlFile ? (
                                            <iframe name="pdfviwer" src={urlFile} onError={(e) => console.error('Error loading PDF:', e)}></iframe>
                                        ) : (
                                            <p>Cargando PDF...</p>
                                        )
                                    )}
                                    {fileType === `"jpg"` || fileType === "png" &&
                                        (
                                            <img src={urlFile} alt="Image Preview" width="100%" />
                                        )
                                    }
                                    {fileType !== "pdf" && "jpg" && "png" &&
                                        <>
                                            <a href={donwloadURL} target='_blank'>Clic aquí para descargar el archivo {bean.Media}</a>
                                        </>
                                    }
                                </>
                                :
                                <>
                                    No se pudo cargar el Documento
                                </>
                            }
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalC} updateModal={setModalC} >
                <HistoryUBLInvoice _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalFire} updateModal={setModalFire} >
                <FireElectronicDocument _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalSeeDoc} updateModal={setModalSeeDoc} >
                <AccountantDocumentList _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalUBL} updateModal={setModalUBL} eventModal={() => { update() }} >
                <MakeUBLInvoice catalog _onChange={(e) => { console.log(e) }} />
            </Modal>


        </>
    )
}